<div class="gird flex align-items-center justify-content-center">
    <div class="col-12 md:col-6 lg:col-6 p-10">
        <p-card class="card">
            <template #title>{{app_base_data.app_name}}</template>
            <template #subtitle>{{app_base_data.company_name}}</template>
            <template #content>
                <h5 class="text-center">
                    <img v-if="app_base_data.main_icon !== ''" class="rounded-circle shadow-4-strong" alt="avatar2"
                        width="90" height="90" :src="app_base_data.main_icon" /> <br>
                    <b>Register</b>
                </h5>
                <p class="text-center m-0"><i><b>Pendaftaran User Baru</b></i></p>

                <p class="m-5">
                    <p-message v-if="error" severity="error">{{error}}</p-message>
                    <p-message v-if="success" severity="success">{{success}}</p-message>

                <!---------------------------------------------------------------------------->  
                <form @submit.prevent="submit" v-if="!success">
                    <div class="field grid">
                        <label for="username" class="col-12 mb-2 md:col-4 md:mb-0">Username *</label>
                        <div class="col-12 md:col-8">
                            <p-inputtext :class="{'p-invalid' : errors?.username}" v-model="username" id="username"
                                type="text" class="w-full border-solid border-round" size="small" />
                            <span class="text-red-600" v-for="(item, index) in errors?.username" :key="index">{{ item
                                }}</span>
                        </div>
                    </div>


                    <div class="field grid">
                        <label for="email" class="col-12 mb-2 md:col-4 md:mb-0">Email *</label>
                        <div class="col-12 md:col-8">
                            <p-inputtext :class="{'p-invalid' : errors?.email}" v-model="email" id="email" type="text"
                                class="w-full border-solid border-round" size="small" />
                            <span class="text-red-600" v-for="(item, index) in errors?.email" :key="index">{{ item
                                }}</span>
                        </div>
                    </div>

                    <div class="field grid">
                        <label for="name" class="col-12 mb-2 md:col-4 md:mb-0">Nama Lengkap *</label>
                        <div class="col-12 md:col-8">
                            <p-inputtext :class="{'p-invalid' : errors?.name}" v-model="name" id="name" type="text"
                                class="w-full border-solid border-round" size="small" />
                            <span class="text-red-600" v-for="(item, index) in errors?.name" :key="index">{{ item
                                }}</span>
                        </div>
                    </div>

                    <div class="field grid">
                        <label for="password" class="col-12 mb-2 md:col-4 md:mb-0">Password *</label>
                        <div class="col-12 md:col-8">
                            <p-inputtext :class="{'p-invalid' : errors?.password}" v-model="password" id="password"
                                type="password" class="w-full border-solid border-round" size="small" />
                            <span class="text-red-600" v-for="(item, index) in errors?.password" :key="index">{{ item
                                }}</span>
                        </div>
                    </div>

                    <div class="field grid">
                        <label for="confirm_password" class="col-12 mb-2 md:col-4 md:mb-0">Confirm Password *</label>
                        <div class="col-12 md:col-8">
                            <p-inputtext :class="{'p-invalid' : errors?.confirm_password}" v-model="confirm_password"
                                id="confirm_password" type="password" class="w-full border-solid border-round"
                                size="small" />
                            <span class="text-red-600" v-for="(item, index) in errors?.confirm_password" :key="index">{{
                                item }}</span>
                        </div>
                    </div>

                    <div class="field grid" v-if="app_base_config.register.show_role">
                        <label for="roles" class="col-12 mb-2 md:col-4 md:mb-0">Roles</label>
                        <div class="col-12 md:col-8">
                            <p-multiselect id="roles" v-model="user_roles" :class="{'p-invalid' : errors?.roles}"
                                :options="roles" filter optionLabel="name" placeholder="Select Roles"
                                :maxSelectedLabels="3" class="w-full border-solid border-round" />
                            <span class="text-red-600" v-for="(item, index) in errors?.roles" :key="index">{{ item
                                }}</span>
                        </div>
                    </div>

                    <p-button @click="submit" :icon="is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'"
                        :disabled="is_loading" label="Register" class="w-full" severity="success" size="small" outlined
                        rounded />
                </form>
                <!---------------------------------------------------------------------------->
                <p-button v-else @click="success = false" class="w-full" label="New Register" severity="warning" outlined rounded />
                <!---------------------------------------------------------------------------->
                <div class="text-center mt-5">
                    <router-link to="/login">---LOGIN---</router-link>
                </div>

                </p>
            </template>
        </p-card>
    </div>

</div>